import { createAction } from '@ngrx/store';

export const ProductDetailsPageLoad = createAction(
  '[GA Product Details] Page Load'
);

export const ProductDetailsContinueClick = createAction(
  '[GA Product Details] Continue Click'
);

export const ProductDetailsThumbnailClick = createAction(
  '[GA Product Details] Thumbnail Click'
);

export const DeliveryUnavailableModal = createAction(
  '[GA Product Details] Delivery Unavailable Modal'
);

export const DeliveryApiErrorModal = createAction(
  '[GA Product Details] Delivery Api Error Modal'
);

export type ProductDetailsActions =
  | typeof ProductDetailsPageLoad
  | typeof ProductDetailsContinueClick
  | typeof ProductDetailsThumbnailClick
  | typeof DeliveryUnavailableModal
  | typeof DeliveryApiErrorModal;
